// extracted by mini-css-extract-plugin
export default {"patternDatesMeta":"CalendarWidget_patternDatesMeta__TxSzD","dateTypePicker":"CalendarWidget_dateTypePicker__6Ognu"};